import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";

const RequireAuth = (props) => {
  const history = useHistory();
  const { Component } = props;
  const [auth, setAuth] = useState(false);

  const MemoziedComponent = useMemo(() => {
    return Component;
  }, [Component]);

  const checkAuth = () => {
    const isLoggedIn = JSON.parse(sessionStorage.getItem("isLoggedIn"));
    isLoggedIn ? setAuth(true) : setAuth(false);
    !isLoggedIn && history.push("/");
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return auth && <MemoziedComponent {...props} />;
};

export default RequireAuth;
